/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

import type { BuildingListingCollection } from '@zcode/bizos'
import type { MaybeEmpty } from '@zcode/utility-types'

/**
 * Returns the `favorites` to be used in messages and tour request payload
 * `favorites` follows the "group_id" format:
 * Listing id: entity.listing_id
 * Building id: -entity.building_id
 *
 * @param favorites favorites object from redux state
 * @param favorites.listings favorited listings: key is the listing id
 * @param favorites.buildings favorited buildings: key is the building id
 * @returns the list of favorites listing and building ids
 */
export const getMessageFavoritesPayload = (favorites: MaybeEmpty<BuildingListingCollection>) => {
  const { listings = {}, buildings = {} } = favorites || {}
  return [
    ...Object.keys(listings).map((id) => Number(id)),
    ...Object.keys(buildings).map((id) => -Number(id)),
  ]
}
